import { Routes } from '@angular/router';
import { MyReferralsComponent } from './my-referrals.component';
import { MyReferralInfoComponent } from './my-referral-info/my-referral-info.component';
import { MyReferralsMyInfoComponent } from './my-referrals-my-info/my-referrals-my-info.component';

export const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'leftSidebar.buildYourNetwork' },
    component: MyReferralsComponent,
    children: [
      { path: '', data: { breadcrumb: null }, component: MyReferralsMyInfoComponent },
      {
        path: 'referral/:id',
        data: { breadcrumb: 'replacer=referralName' },
        component: MyReferralInfoComponent
      }
    ]
  }
];
